import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';
import {CoverNote, RecordCount} from '../../Config/dataModel';

interface PolicyContainerProps {
    newRecord?: CoverNote,
    newCount?: RecordCount
}

class PolicyContainer extends React.Component <PolicyContainerProps, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.POLICY} newRecord={this.props.newRecord} newCount={this.props.newCount}/>
        );
    }
}

export default PolicyContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/PolicyContainer.tsx